import React, { useContext, useEffect, useState } from 'react'
import Header from '../../Components/Header'
import MyCourses from './Components/MyCourses'
import Account from './Components/Account'
import LogoutIcon from '@mui/icons-material/Logout';
import { appContext } from '../../Context/appProvider';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { baseUrl, path, TOKEN_KEY } from '../../constants';
import WishLists from './Components/WishLists';
import { settingsContext } from '../../Context/settingsProvider';

export default function Profile() {
    const {setToken, token} = useContext(appContext)
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search);
    const tabs = ['courses', 'wishlist', 'account']
    const [tab, setTab] = useState(tabs.indexOf(queryParams.get('tab') || 'courses'))
    const {t} = useContext(settingsContext)

    const TabComponents = [MyCourses, WishLists, Account]
    const SelectedTab = TabComponents[tab]

    const navigate = useNavigate()
    const logout = () => {
        setToken(null)
        localStorage.setItem(TOKEN_KEY, null)
        navigate('/login')
    }

    return (
    <div className='w-full h-screen flex flex-1 flex-col bg-[#f2f2f2] pt-[60px]'>
        <Header withLogo />
        <div className='flex w-full flex-col gap-2 p-3'>
            <div className='flex items-center gap-3'>
                <h2 className='text-black text-[27px]'>{t('PROFILE')}</h2>
                <button onClick={logout} className='outline-none border-none bg-black w-[50px] h-[25px] rounded-md flex items-center justify-center'>
                    <LogoutIcon style={{fontSize: 18, color: '#ffffff'}}>Filled</LogoutIcon>
                </button>
            </div>
            <div className='w-full border-b-[1px] border-b-[#00000030] border-b-solid flex gap-5 items-center'>
                <p onClick={() => setTab(0)} className='p-3 border-b-black border-b-solid text-black text-[14px] cursor-pointer' style={{
                    borderBottomWidth: tab == 0 ? 2 : 0
                }}>
                    {t('MY_COURSES')}
                </p>
                <p onClick={() => setTab(1)} className='p-3 border-b-black border-b-solid text-black text-[14px] cursor-pointer' style={{
                    borderBottomWidth: tab == 1 ? 2 : 0
                }}>
                    {t('WISHLISTS')}
                </p>
                <p onClick={() => setTab(2)} className='p-3 border-b-black border-b-solid text-black text-[14px] cursor-pointer' style={{
                    borderBottomWidth: tab == 2 ? 2 : 0
                }}>
                    {t('ACCOUNT')}
                </p>
            </div>
            {<SelectedTab />}
        </div>
    </div>
    )
}